<script>

import {apiOnLineKefuList} from "@/api/app";
import Event from "@/utils/event";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["changeKefu"],

  data() {
    return {
      tableData: [], //全部数据
      filterData: [],  // 搜索过滤后的数据
      pagedData: [],//当前分展示的数据
      fullTableData: [],
      replyLists: [],
      search: '',
      keyword: '',
      /* 分页器 */
      pagination: {
        size: 5,
        page: 1,
        total: 0,
        currentPage: 1
      },
      visible_remarks: false,
      remarks: '',
      row:'',
    }
  },

  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        //监听关闭弹窗
        this.$emit('input', val)
      },
    },
  },

  watch: {
    visible(val) {
      if (val) this.getKefuLists()
    }
  },
  mounted() {
    this.$net.socket.on("getOnlineKefu", (res) => {
      this.tableData = res
      this.filterAndPaginate()
    })
  },
  methods: {
    filterAndPaginate() {
      if(this.tableData.length<=0) return;
      this.filterData = this.tableData
      // 分页计算
      const start = (this.pagination.currentPage - 1) * this.pagination.size;
      const end = start + this.pagination.size;
      this.pagedData = this.filterData.slice(start, end);
    },

    async getKefuLists() {
      //获取当前客服的id
      let id = this.$net.userInfo.user_id

      this.$net.socket.emit("getOnlineKefu",{kefu_id:'kefu_'+id});
    },

    handleEdit(index, row) {
      /**
       * 打开弹窗
       */
      this.row = row
      this.visible_remarks = true
    },

    pageSizeChange(newSize) {
      this.pagination.size = newSize;
      this.pagination.currentPage = 1;
      this.filterAndPaginate();
    },

    pageCurrentChange(newPage) {
      this.pagination.currentPage = newPage;
      this.filterAndPaginate();
    },

    btnOk() {
      this.$emit('changeKefu', this.row,this.remarks) //刷新客服
      Event.$emit('refreshKefu')//刷新客服
      //先关闭备注弹窗
      this.visible_remarks = false
      //再关闭转接客服闭弹窗
      this.$emit('input', false)
    },

    btnCancle() {
      this.row = ''
      this.remarks = ''
      this.visible_remarks = false
    }

  }
}
</script>

<template>
  <div class="change-kefu">
    <!--  转接客服弹出框  -->
    <el-dialog
        title="转接客服"
        :visible.sync="visible"
        width="600px"
        top="20vh"
    >
      <el-table
          :data="pagedData.filter(data => !search || data.data.nickname.toLowerCase().includes(search.toLowerCase()))"
          border
          height="300"
          style="width: 100%">
        <el-table-column prop="data.nickname" label="客服名称" width="180"></el-table-column>

        <el-table-column align="center">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="search"
                size="mini"
                placeholder="输入关键字搜索"/>
          </template>

          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">转接
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[1,5, 10, 20, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.length">
      </el-pagination>

    </el-dialog>

    <!--  转接备注弹出框  -->
    <el-dialog
        title="转接客服"
        :visible.sync="visible_remarks"
        width="400px"
        top="20vh"
        :center="true"
    >
      <el-input v-model="remarks" type="textarea" placeholder="请输入备注信息"></el-input>

      <div class="btnMenu">
        <el-button type="primary" @click="btnOk" style="margin-right: 10px">确定</el-button>
        <el-button type="danger" plain @click="btnCancle">取消</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.change-kefu {
  .btnMenu {
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>